import { createContext, useContext } from "react";
//import { propEq } from 'ramda'
//import { useNavigate } from 'react-router-dom'

import { useQuery } from "react-query";
import { healthCheck } from "@webapi/api";
import { jsx as _jsx } from "react/jsx-runtime";
export var HealthcheckContext = /*#__PURE__*/createContext({});
export var HealthcheckContextProvider = function HealthcheckContextProvider(props) {
  //const navigate = useNavigate()

  var _useQuery = useQuery(["healthcheck"], healthCheck),
    healthcheckResponse = _useQuery.data;

  //TODO fix so that they can render when empty?
  // const database = healthcheckResponse?.Checkpoints?.find(propEq('Name', 'Databas'))
  // const databaseIsDown = database ? !database.IsHealthy : false
  //
  // useEffect(() => {
  //   if(databaseIsDown) navigate('/internt-serverfel?database=true', { replace: true })
  //   else if(serverError) navigate('/internt-serverfel', { replace: true })
  // }, [databaseIsDown, serverError])

  if (!healthcheckResponse) return null;
  return /*#__PURE__*/_jsx(HealthcheckContext.Provider, {
    value: {
      healthcheckResponse: healthcheckResponse
    },
    children: props.children
  });
};
export var useHealthcheckContext = function useHealthcheckContext() {
  return useContext(HealthcheckContext);
};